export default "__VITE_ASSET__Q6H46tiWD5KOWdRjlUA61w__"